module.exports = __webpack_public_path__ + "media/images/icon-shield-7c4bb52a779d77a293a33bb05d2a3c8f.svg";